<template>
  <div>
    <div class="memberWrap">
      <jField label="会员姓名">
        <van-field
          v-model="memberForm.memberName"
          :border="false"
          placeholder="请输入用户名"
        />
      </jField>
      <jField label="性别">
        <span
          class="sex fmal"
          :class="[memberForm.gender === 'F' ? 'select' : '']"
          @click="memberForm.gender = 'F'"
          >女</span
        >
        <span
          class="sex man"
          :class="[memberForm.gender === 'M' ? 'select' : '']"
          @click="memberForm.gender = 'M'"
          >男</span
        >
      </jField>
      <jField label="手机号">
        {{ memberForm.cellPhone ? memberForm.cellPhone : "" }}
      </jField>
      <jField label="职业" :expand="true">
        <van-field
          readonly
          clickable
          :border="false"
          autosize
          :value="memberForm.occupation"
          placeholder="选择职业"
          @click="showPicker = true"
        />
      </jField>
      <jField label="生日" :expand="true">
        <van-field
          readonly
          clickable
          :border="false"
          :value="memberForm.birthday"
          placeholder="选择生日"
          @click="showBirth = true"
        />
      </jField>
      <jField label="注册日期">
        {{
          memberData
            ? $moment(memberData.registerDate).format("YYYY-MM-DD")
            : ""
        }}
      </jField>
    </div>

    <div class="detail-nav">
      <div @click="exitLogin" class="logout">退出登录</div>
      <div class="savebtn" @click="submitChanges">完成</div>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>

    <van-popup v-model="showBirth" position="bottom">
      <van-datetime-picker
        v-model="selbirthday"
        type="date"
        :min-date="minDate"
        @cancel="showBirth = false"
        @confirm="onBirthConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import jField from "./jField";

export default {
  name: "",
  components: {
    jField,
  },
  data() {
    return {
      memberForm: {
        memberName: "",
        cellPhone: "",
        gender: "",
        occupation: "",
        birthday: "",
        identityNumber: "",
        memberId: "",
      },
      memberData: null,
      columns: ["务工", "务农", "个体"],

      showPicker: false,
      showBirth: false,
      minDate: new Date("1920-01-01"),
      selbirthday: new Date(),
    };
  },
  mounted() {
    this.getUserInfo();
    let initTime = this.initTime;
    this.$service.getStatisCommon("evn_dom_finish", { initTime: initTime });
    this.getCustomerInfo()
  },
  methods: {
    async getUserInfo() {
      try {
        let memberId = localStorage.getItem(this.$env + "memberId");
        let res = await this.$service.getMemberV1(memberId);
        if (res.status === 200) {
          this.memberData = res.result;
          this.memberForm = res.result;
          this.memberForm.memberName = res.result.memberName;
          this.memberForm.cellPhone = res.result.cellPhone;
          this.memberForm.occupation = res.result.occupation
            ? res.result.occupation
            : "";
          this.memberForm.birthday = res.result.birthday
            ? res.result.birthday
            : "";
          this.memberForm.gender = res.result.gender;
          this.memberForm.memberId = localStorage.getItem(
            this.$env + "memberId"
          );

          this.selbirthday = new Date(res.result.birthday);
          this.getCustomerInfo()
        }
      } catch (e) {
        if (e.status === 401) {
          this.$login("memberDetail");
        } else {
          this.$toast("服务器错误，请稍后重试。。。");
        }
      }
      let initTime = this.initTime;
      this.$service.getStatisCommon("evn_open_page", { initTime: initTime });
    },
    async submitChanges() {
      this.$toast.loading({
        duration: 0,
        forbidclick: true,
      });
      try {
        let params = this.memberForm;
        let res = await this.$service.updateMemberV1(params);
        this.$toast.clear();
        this.$toast.success("保存成功");
        // this.$router.push({path:"/"})
        this.$reLaunch("member", "");
      } catch (e) {
        this.$toast.clear();
      }
      this.$service.getStatisCommon("evn_close_page", {});
    },
    exitLogin() {
      this.sendStatics('event_quit_register',{currentUrl:36,module:90})
      this.$logout();
      // this.$store.commit("shopcar/UPD_SHOPCAR_NUM",0)
      // this.$router.push({path:"/"})
      // this.$navigateTo("member","")
      setTimeout(() => {
        this.$reLaunch("member", { loginout: true });
      }, 10);

      // this.$wx.miniProgram.navigateBack()
      this.$service.getStatisCommon("evn_close_page", {});
    },
    onConfirm(value) {
      this.memberForm.occupation = value;
      this.showPicker = false;
    },
    onBirthConfirm(value) {
      this.memberForm.birthday = this.$moment(value).format("YYYY-MM-DD");
      this.showBirth = false;
    },
    async getCustomerInfo() {
      let res = await this.$service.getCustomerInfo();
      if (res.status === 200)
        this.memberForm.memberName = res.result.memberName;
    },
  },
};
</script>
<style scoped lang='less'>
.detail-nav {
  display: flex;
  justify-content: center;
  position: fixed;
  width: 100%;
  bottom: 0;
  font-size: 16px;
}
.logout {
  height: 1.28rem;
  line-height: 1.28rem;
  width: 50%;
  position: relative;
  text-align: center;
  color: rgb(235, 97, 15);
  background: #fff;
}
.savebtn {
  height: 1.28rem;
  line-height: 1.28rem;
  width: 50%;
  position: relative;
  color: #fff;
  background: linear-gradient(to right, #eb6112, #febb5c);
  text-align: center;
}

.memberWrap {
  .van-cell {
    padding: 10px 0;
    font-size: 16px;
  }
}
.sex {
  display: inline-block;
  width: 1.7333rem;
  height: 0.72rem;
  padding-left: 0.96rem;
  line-height: 0.72rem;
  background: #e5e5e5;
  color: #fff;
  border-radius: 0.72rem;
  // background:#EB6212;
  position: relative;
}
.sex::before {
  content: "";
  width: 0.4267rem;
  height: 0.4267rem;
  position: absolute;
  top: 5px;
  left: 10px;
}
.sex.select {
  background: #eb6212;
}
.fmal {
  margin-right: 10px;
}
.fmal::before {
  background: url("../../assets/images/ic-girl.png") no-repeat;
  background-size: 100% 100%;
}
.man::before {
  background: url("../../assets/images/ic-boy.png") no-repeat;
  background-size: 100% 100%;
}
</style>